import { ProcessingScreen } from '@components'

import { ModuleLayout } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { InvoicesList as InvoicesListFeature } from '@features/invoices/elements/InvoicesList'
import { InvoiceDocumentType } from '@features/invoices/enums/invoiceDocumentType'
import { useHasInvoices } from '@features/invoices/hooks/useHasInvoices'
import { getInvoiceDocumentRouteBase } from '@features/invoices/utils/getInvoiceDocumentRouteBase'
import { InvoicesListSideActions } from '@views/externalInvoices/routes/InvoicesList/elements/InvoicesListSideActions'

import { TableIds } from '../../../../enums/tableIds'
import { useOrganizationViewUrl } from '../../../../hooks/routing/useOrganizationViewUrl'
import { reactRoute } from '../../../../utils/routing/reactRoute'
import { InvoicesListEmpty } from './elements/InvoicesListEmpty'
import { InvoicesSummary } from './elements/InvoicesSummary'

const invoiceDocumentRouteBase = getInvoiceDocumentRouteBase(InvoiceDocumentType.Invoice)

export const InvoicesList = (): ReactElement => {
  const { t } = useTranslation()
  const { hasInvoices, isFetching } = useHasInvoices()

  const { url: invoiceNewUrl } = useOrganizationViewUrl(
    reactRoute.organization.invoices.getNewDocumentRoute(invoiceDocumentRouteBase),
  )

  if (isFetching) {
    return <ProcessingScreen />
  }

  return (
    <ModuleLayout title={t('invoices')} sideActions={hasInvoices ? <InvoicesListSideActions /> : null}>
      {!hasInvoices ? (
        <InvoicesListEmpty />
      ) : (
        <>
          <InvoicesSummary />
          <InvoicesListFeature
            showColumnsFilteringInActions
            newDocumentUrl={invoiceNewUrl ?? ''}
            tableId={TableIds.ExternalInvoicesList}
          />
        </>
      )}
    </ModuleLayout>
  )
}
